import { STATUS_TYPE } from '../../../enum';
import { Country } from '../../country/api/interface';

export interface FindRegion {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetRegion {
  id: string;
}

export interface CreatePatchRegion {
  id?: string;
  labelEn: string;
  labelAr: string;
  code: string;
  countryId: string;
  // ccy: string;
  decimalPlaces: string;
  deliveryFee: string;
  vatRate: string;
  printingCharges: string;
  // deliveryDayGap: string;
  // deliveryUpto: string;
  isVatOnus: boolean;

  // isMessageCardEnabled: boolean;
  // isGiftCodeEnabled: boolean;
  // isEarlyAccess: boolean;
  // isWalletEnabled: boolean;
  // isAddonEnabled: boolean;
  // isCakeColorPickerEnabled: boolean;
  // isWriteColorPickerEnabled: boolean;
  // isToppingsOndemandLabelFastDelivery: boolean;
  activeState: boolean;
}

export interface Region {
  id: string;
  labelEn: string;
  labelAr: string;
  code: string;
  countryId: string;
  country: Country;
  // ccy: string;
  decimalPlaces: string;
  deliveryFee: string;
  vatRate: string;
  printingCharges: string;
  // deliveryDayGap: string;
  // deliveryUpto: string;
  isVatOnus: boolean;
  // isMessageCardEnabled: boolean;
  // isGiftCodeEnabled: boolean;
  // isEarlyAccess: boolean;
  // isWalletEnabled: boolean;
  // isAddonEnabled: boolean;
  // isCakeColorPickerEnabled: boolean;
  // isWriteColorPickerEnabled: boolean;
  // isToppingsOndemandLabelFastDelivery: boolean;
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: Region[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
